<template>
    <v-text-field
        :class="{ outlined: outlined }"
        v-model="input"
        autocomplete="off"
        append-icon="mdi-timer"
        v-mask="'##:##'"
        :label="label"
        :solo="outlined"
        :dense="dense"
        :disabled="disabled"
        @blur="checkTimeFormat()"
        :error-messages="errorMessages"
        @keyup="formattingTime($event)">
    </v-text-field>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
    name: 'HoursInput',

    directives: {
        mask
    },

    props: {
        value: {
            type: String,
            default: '01:00'
        },

        errorMessages: {
            type: [String, Array],
            default: null
        },

        outlined: {
            type: Boolean,
            default: false
        },

        dense: {
            type: Boolean,
            default: false
        },

        disabled: {
            type: Boolean,
            default: false
        },

        defaultValue: {
            type: String,
            default: '01:00'
        },

        label: {
            type: String,
            default: ''
        }
    },

    data () {
        return {
            input: this.value
        }
    },

    methods: {
        formattingTime (e) {
            const value = e.target.value
            if (e.keyCode === 186) {
                this.input = this.addColon(value)
            } else if (e.keyCode !== 8) {
                this.input = this.checkTime(value)
            }
        },

        addColon (value) {
            if (value.length === 1) {
                return `0${value}:`
            }
            return value
        },

        checkTime (value) {
            if (value.length === 1 && value > 2) {
                return `0${value}:`
            }
            if (value.length === 2 && value > 23) {
                return '23:'
            } else if (value.length === 2 && value < 23) {
                return `${value}:`
            }
            if (value.length === 5) {
                let [hour, minute] = value.split(':')
                if (value.split(':')[1] > 59) {
                    minute = 59
                }
                if (value.split(':')[0] > 23) {
                    hour = 23
                }
                return `${hour}:${minute}`
            }
            return `${value}`
        },

        checkTimeFormat () {
            if (this.input.length === 1) {
                this.input = `0${this.input}:00`
            } else if (this.input.length === 3) {
                this.input = `${this.input}00`
            } else if (this.input.length === 4) {
                this.input = `${this.input}0`
            } else if (this.input.length === 0) {
                this.input = this.defaultValue
            }

            this.$emit('input', this.input)
        }
    },

    watch: {
        value (newValue, oldValue) {
            this.input = newValue
        }
    }
}
</script>

<style lang="scss" scoped>
.outlined {
    ::v-deep .v-input__control > .v-input__slot {
        box-shadow: none !important;
        border: 1px solid #A8A8A8 !important;
        border-radius: 5px;
    }

    &::v-deep.error--text .v-input__control > .v-input__slot {
        border: 1px solid #FF5252 !important;
    }
}
</style>
